import axios, { AxiosResponse } from 'axios';

const youtubeApi = axios.create({
  baseURL: process.env.VUE_APP_YOUTUBE_API_URL,
  headers: {
    createdate: process.env.VUE_APP_YOUTUBE_API_HEADER_CREATEDATE,
    token: process.env.VUE_APP_YOUTUBE_API_HEADER_TOKEN,
    website: window.location.hostname,
  },
});

const getUserData = async (
  payload: Services.LiveSocial.Youtube.GetUserData,
): Promise<AxiosResponse<Services.LiveSocial.Youtube.Response.GetUserData>> => (
  youtubeApi.get('authenticate/', { params: payload })
);

const postBindBroadcastToStream = async (
  payload: Services.LiveSocial.Youtube.PostBindBroadcastToStream,
): Promise<AxiosResponse<Services.LiveSocial.Youtube.Response.PostBindBroadcastToStream>> => (
  youtubeApi.post(`live/bind-broadcast-to-stream/${payload.user_id}`, {
    ...payload,
    part: payload.part.join(),
    user_id: undefined,
  })
);

const postLiveBroadcast = async (
  payload: Services.LiveSocial.Youtube.PostLiveBroadcast,
): Promise<AxiosResponse<Services.LiveSocial.Youtube.Response.PostLiveBroadcast>> => (
  youtubeApi.post(`live/broadcast/${payload.user_id}`, {
    ...payload,
    part: payload.part.join(),
  })
);

const postLiveStream = async (
  payload: Services.LiveSocial.Youtube.PostLiveStream,
): Promise<AxiosResponse<Services.LiveSocial.Youtube.Response.PostLiveStream>> => (
  youtubeApi.post(`live/stream/${payload.user_id}`, {
    ...payload,
    part: payload.part.join(),
    user_id: undefined,
  })
);

// youtube api target calls
const removeWowzaTarget = async (
  payload: Services.LiveSocial.Youtube.RemoveWowzaTarget,
): Promise<AxiosResponse> => {
  const { application, streamtargetname } = payload;

  return youtubeApi.delete(`/stream-target/${application}/${streamtargetname}`);
};

const createWowzaTarget = async (
  payload: Services.LiveSocial.Youtube.CreateWowzaTarget,
): Promise<AxiosResponse> => (
  youtubeApi.post('stream-target', payload)
);

const changeWowzaTarget = async (
  payload: Services.LiveSocial.Youtube.ChangeWowzaTarget,
): Promise<AxiosResponse> => {
  const { application, streamtargetname, action } = payload;

  return youtubeApi.put(`/stream-target/${application}/${streamtargetname}/${action}`);
};

const youtube = {
  getUserData,
  postBindBroadcastToStream,
  postLiveBroadcast,
  postLiveStream,
  removeWowzaTarget,
  createWowzaTarget,
  changeWowzaTarget,
};

export default youtube;
